<div class="bg">
  <div class="wrapper">
    <div class="home" routerLink="/">
      <img src="../../../../assets/images/studenty.png" routerLink="/"/><span style="color: #ffff;">Back to home</span>
    </div>
    <div class="headline">
      <h1>Create new password?</h1>
    </div>
    <form class="body" [formGroup]="form_group" (ngSubmit)="onSubmit()">
      <div style="color:#ffff;padding-bottom: 10px;padding-left: 15px;">Password</div>
      <div class="signup">
        <div class="form-group" [ngClass]="{ 'is-invalid': submitted && f.password1.errors }">
          <input
            [type]="showPass1 ? 'text' : 'password'"
            class="form-control"
            formControlName="password1"
            placeholder="password"
          />
          <fa-icon
            [icon]="faEye"
            style="display: flex;float: right; transform: translateY(-230%);margin-right: 2%;cursor: pointer; color: #79d1ef; font-size: x-large;"
            class="material-icons"
            matSuffix
            (click)="showPass1 = !showPass1"
          >
            {{ hide ? 'Show' : 'Hide' }}
          </fa-icon>
          <label style="color:white;">Password</label>
        </div>
        <span *ngIf="submitted && f.password1.errors?.required" class="error-msg">Please enter your password</span>
        <span *ngIf="submitted && f.password1.errors?.minlength" class="error-msg">Password must be at least 6 characters</span>

        <div class="form-group" [ngClass]="{ 'is-invalid': submitted && !match }">
          <input
            [type]="showPass2 ? 'text' : 'password'"
            formControlName="password2"
            class="form-control"
            placeholder="confirm password"
            [ngClass]="{ 'is-invalid': submitted && !match }"
            (change)="handlePass2Change($event)"
          />
          <fa-icon
            [icon]="faEye"
            style="display: flex;float: right; transform: translateY(-230%);margin-right: 2%;cursor: pointer; color: #79d1ef; font-size: x-large;"
            class="material-icons"
            matSuffix
            (click)="showPass2 = !showPass2"
          >
            {{ hide ? 'Show' : 'Hide' }}
          </fa-icon>
        </div>
        <span *ngIf="submitted && !match" class="error-msg">Password does not match</span>

        <!-- BUTTONS -->
        <div style="display: flex;gap: 1rem;">
          <button class="btn" [disabled]="form_group.invalid || !match">Confirm</button>
        </div>

        <p class="have_account">
          <a routerLink="/login">Back to sign in</a>
        </p>
        <!-- BUTTONS -->
      </div>
    </form>
  </div>
</div>
